import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issues: {
		id: 'spa-apps-sidebar-common.issues.default-filters.issues',
		defaultMessage: 'Issues and filters',
		description: 'Navigation item which links to or from a issues page in a software project',
	},
	issuesFilters: {
		id: 'spa-apps-sidebar-common.issues.default-filters.issues-filters',
		defaultMessage: 'Issues and Filters',
		description: '"Issues and Filters" menu item.',
	},
	myOpenIssues: {
		id: 'spa-apps-sidebar-common.issues.default-filters.my-open-issues',
		defaultMessage: 'My open issues',
		description: 'Filter link on the issues view in software navigation',
	},
	reportedByMe: {
		id: 'spa-apps-sidebar-common.issues.default-filters.reported-by-me',
		defaultMessage: 'Reported by me',
		description: 'Filter link on the issues view in software navigation',
	},
	allIssues: {
		id: 'spa-apps-sidebar-common.issues.default-filters.all-issues',
		defaultMessage: 'All issues',
		description: 'Filter link on the issues view in software navigation',
	},
	allOpenIssues: {
		id: 'spa-apps-sidebar-common.issues.default-filters.all-open-issues',
		defaultMessage: 'Open issues',
		description: 'Filter link on the issues view in software navigation',
	},
	doneIssues: {
		id: 'spa-apps-sidebar-common.issues.default-filters.done-issues',
		defaultMessage: 'Done issues',
		description: 'Filter link on the issues view in software navigation',
	},
	viewedRecently: {
		id: 'spa-apps-sidebar-common.issues.default-filters.viewed-recently',
		defaultMessage: 'Viewed recently',
		description: 'Filter link on the issues view in software navigation',
	},
	createdRecently: {
		id: 'spa-apps-sidebar-common.issues.default-filters.created-recently',
		defaultMessage: 'Created recently',
		description: 'Filter link on the issues view in software navigation',
	},
	resolvedRecently: {
		id: 'spa-apps-sidebar-common.issues.default-filters.resolved-recently',
		defaultMessage: 'Resolved recently',
		description: 'Filter link on the issues view in software navigation',
	},
	updatedRecently: {
		id: 'spa-apps-sidebar-common.issues.default-filters.updated-recently',
		defaultMessage: 'Updated recently',
		description: 'Filter link on the issues view in software navigation',
	},
	issuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh',
		defaultMessage: 'Work items and filters',
		description: 'Navigation item which links to or from a issues page in a software project',
	},
	issuesFiltersIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh',
		defaultMessage: 'Work items and filters',
		description: '"Issues and Filters" menu item.',
	},
	myOpenIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh',
		defaultMessage: 'My open work items',
		description: 'Filter link on the issues view in software navigation',
	},
	allIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh',
		defaultMessage: 'All work items',
		description: 'Filter link on the issues view in software navigation',
	},
	allOpenIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh',
		defaultMessage: 'Open work items',
		description: 'Filter link on the issues view in software navigation',
	},
	doneIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh',
		defaultMessage: 'Done work items',
		description: 'Filter link on the issues view in software navigation',
	},
});
